// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Blog_Blog__YPcyh {
    display: flex;
    justify-content: center;
    align-items: baseline;
    font-family: 'Aktiv Grotesk', sans-serif;
    font-size: 0.8rem;
    color: #0a2945; 
    flex-wrap: wrap;
}
.Blog_BlogTitle__c\\+KpV {
    margin-top: 90px;
    width: 100%;
    text-align: center;
    font-family: 'Cocon Bold';
    font-size: 3em;
}
.Blog_BlogHeader__BfyJe {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 0 2rem 0;
    padding: 0 0 2rem 0;
    border-bottom: 1px solid #ccc;
}
.Blog_BlogBorder__bX2ON {
    width: 90%;
    margin: 0 5%;
}
.Blog_FeaturedArticle__F0RKw {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 2rem;
    /* max-width: 800px; */
    width: 43%;
}

.Blog_FeaturedArticle__F0RKw img {
    width: 100%;
}

.Blog_FeaturedCover__SrVIf {
    margin-top: 0.5rem;
}

.Blog_FeaturedDesc__I4jRu {
    width: 100%;
    text-align: left;
    font-weight: 600;
    font-size: 18px;
}
.Blog_FeaturedDesc__I4jRu a{
   color: #589542 !important;
}

.Blog_FeaturedByline__bEQCj {
    width: 100%;
    margin-bottom: 0.5rem;
    font-size: 0.75rem;
    color: darkgray;
    text-align: right;
    font-size: 14px;
}

@media screen and (max-width: 992px) {
    .Blog_FeaturedArticle__F0RKw {
        width: 80% !important;
    }
}
@media screen and (max-width: 768px) {
    .Blog_FeaturedByline__bEQCj {
        font-size: 10px;
    }
    .Blog_FeaturedDesc__I4jRu {
        font-size: 13px;
    }
    .Blog_BlogTitle__c\\+KpV {
        font-size: 2em;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Blog/Blog.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,wCAAwC;IACxC,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;GACG,yBAAyB;AAC5B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".Blog {\n    display: flex;\n    justify-content: center;\n    align-items: baseline;\n    font-family: 'Aktiv Grotesk', sans-serif;\n    font-size: 0.8rem;\n    color: #0a2945; \n    flex-wrap: wrap;\n}\n.BlogTitle {\n    margin-top: 90px;\n    width: 100%;\n    text-align: center;\n    font-family: 'Cocon Bold';\n    font-size: 3em;\n}\n.BlogHeader {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0 0 2rem 0;\n    padding: 0 0 2rem 0;\n    border-bottom: 1px solid #ccc;\n}\n.BlogBorder {\n    width: 90%;\n    margin: 0 5%;\n}\n.FeaturedArticle {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 2rem;\n    /* max-width: 800px; */\n    width: 43%;\n}\n\n.FeaturedArticle img {\n    width: 100%;\n}\n\n.FeaturedCover {\n    margin-top: 0.5rem;\n}\n\n.FeaturedDesc {\n    width: 100%;\n    text-align: left;\n    font-weight: 600;\n    font-size: 18px;\n}\n.FeaturedDesc a{\n   color: #589542 !important;\n}\n\n.FeaturedByline {\n    width: 100%;\n    margin-bottom: 0.5rem;\n    font-size: 0.75rem;\n    color: darkgray;\n    text-align: right;\n    font-size: 14px;\n}\n\n@media screen and (max-width: 992px) {\n    .FeaturedArticle {\n        width: 80% !important;\n    }\n}\n@media screen and (max-width: 768px) {\n    .FeaturedByline {\n        font-size: 10px;\n    }\n    .FeaturedDesc {\n        font-size: 13px;\n    }\n    .BlogTitle {\n        font-size: 2em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Blog": `Blog_Blog__YPcyh`,
	"BlogTitle": `Blog_BlogTitle__c+KpV`,
	"BlogHeader": `Blog_BlogHeader__BfyJe`,
	"BlogBorder": `Blog_BlogBorder__bX2ON`,
	"FeaturedArticle": `Blog_FeaturedArticle__F0RKw`,
	"FeaturedCover": `Blog_FeaturedCover__SrVIf`,
	"FeaturedDesc": `Blog_FeaturedDesc__I4jRu`,
	"FeaturedByline": `Blog_FeaturedByline__bEQCj`
};
export default ___CSS_LOADER_EXPORT___;
